import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './base-query-with-reauth';

export const apiSlice = createApi({
    reducerPath: 'folApi',
    baseQuery: baseQueryWithReauth,
    endpoints: () => ({}),
});
